import {
    MARKETS_ALL_REQUEST,
    MARKETS_ALL_SUCCESS,
    MARKETS_ALL_FAIL,
    MARKETS_REQUEST,
    MARKETS_SUCCESS,
    MARKETS_FAIL,
    PRODUCTS_REQUEST,
    PRODUCTS_SUCCESS,
    PRODUCTS_FAIL,
    MARKET_LOG_REQUEST,
    MARKET_LOG_SUCCESS,
    MARKET_LOG_FAIL,
    SHOW_ONLINE_MARKET_LOG_LIST,
    SHOW_ONLINE_MARKET_LOG_GRID,
    HIDE_ONLINE_MARKET_LOG,
    SHOW_BID_POPUP,
    HIDE_BID_POPUP,
    SHOW_MANAGE_MARKET_POPUP,
    HIDE_MANAGE_MARKET_POPUP,
    SHOW_MANAGE_PRODUCT_POPUP,
    HIDE_MANAGE_PRODUCT_POPUP,
    MARKET_LOG_STORE_ARGS,
    MARKET_LOG_SET_SELECTED_VIEW,
    SHOW_STATUSBAR,
    HIDE_STATUSBAR,
    STORE_STATUSBAR_DATA,
    CLEAN_STATUSBAR_DATA,
    SHOW_MARKETLOG_FILTER,
    HIDE_MARKETLOG_FILTER,
    GET_CUSTOM_VIEW_REQUEST,
    GET_CUSTOM_VIEW_SUCCESS,
    GET_CUSTOM_VIEW_FAIL,
    MARKET_RESET_STATE,
    UPDATE_BID,
    ADD_MARKET_ORDER_NOTIFIKATION,
    REMOVE_MARKET_ORDER_NOTIFIKATION,
} from '../constants/action-types';

const initialState = {
    fetching: false,
    error: '',
    data: [],
    manage: [],
    marketLogData: [],
    products: [],
    customViews: [],
    bidFormData: {},
    marketLogArgs: {},
    marketLogSelectedView: null,
    bidExpirationInterval: null,
    isBidPopupVisible: false,
    isOnlineMarketLogVisible: false,
    isOnlineMarketLogListVisible: false,
    isOnlineMarketLogGridVisible: false,
    isManageMarketPopupVisible: false,
    manageMarketPopupData: {},
    isManageProductPopupVisible: false,
    manageProductPopupData: {},
    isManageTapPopupVisible: false,
    manageTapPopupData: {},
    marketlogFilter: {
        visible: false,
        params: {},
    },
    statusbar: {
        visible: false,
        product_id: '',
        data: [],
        params: {},
    },
    updatingBid: false,
    marketOrderNotifikation: null,
};

export default function markets(state = initialState, action) {
    switch (action.type) {
        case MARKETS_REQUEST:
        case MARKETS_ALL_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case MARKETS_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: '',
                data: action.payload,
            };
        case MARKETS_ALL_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: '',
                manage: action.payload,
            };
        case PRODUCTS_SUCCESS:
            return {
                ...state,
                products: action.payload,
            };
        case MARKETS_FAIL:
        case MARKETS_ALL_FAIL:
        case PRODUCTS_FAIL:
            return {
                ...initialState,
                fetching: false,
                error: action.error || '',
            };
        case MARKET_LOG_REQUEST:
            return {
                ...state,
                marketLogArgs: action.params,
            };
        case MARKET_LOG_SUCCESS:
            const data = action.payload;
            data.forEach(row => {
                for (const intent in row) {
                    row[intent].forEach(order => {
                        if (order.expiry_time) {
                            order.expiry_time = new Date(
                                new Date().getTime() + order.expiry_time_left * 1000,
                            ).toISOString();
                        }
                    });
                }
            });
            return {
                ...state,
                error: '',
                marketLogData: data,
            };
        case MARKET_LOG_FAIL:
            return {
                ...initialState,
                error: action.error || '',
            };
        case SHOW_ONLINE_MARKET_LOG_LIST:
            return {
                ...state,
                isOnlineMarketLogVisible: true,
                isOnlineMarketLogListVisible: true,
                isOnlineMarketLogGridVisible: false,
            };
        case SHOW_ONLINE_MARKET_LOG_GRID:
            return {
                ...state,
                isOnlineMarketLogVisible: true,
                isOnlineMarketLogListVisible: false,
                isOnlineMarketLogGridVisible: true,
            };
        case HIDE_ONLINE_MARKET_LOG:
            return {
                ...state,
                isOnlineMarketLogVisible: false,
                isOnlineMarketLogListVisible: false,
                isOnlineMarketLogGridVisible: false,
                marketOrderNotifikation: null,
            };
        case SHOW_BID_POPUP:
            if (state.bidExpirationInterval) {
                clearInterval(state.bidExpirationInterval);
            }
            return {
                ...state,
                isBidPopupVisible: true,
                bidFormData: action.formData,
                bidExpirationInterval: action.expirationInterval,
            };
        case HIDE_BID_POPUP:
            if (state.bidExpirationInterval) {
                clearInterval(state.bidExpirationInterval);
            }
            return {
                ...state,
                isBidPopupVisible: false,
                bidFormData: {},
                updatingBid: false,
                bidExpirationInterval: null,
            };
        case SHOW_MANAGE_MARKET_POPUP:
            return {
                ...state,
                isManageMarketPopupVisible: true,
                manageMarketPopupData: {
                    mode: action.mode,
                    name: action.name,
                    data: action.data,
                },
            };
        case HIDE_MANAGE_MARKET_POPUP:
            return {
                ...state,
                isManageMarketPopupVisible: false,
                manageMarketPopupData: {},
            };
        case SHOW_MANAGE_PRODUCT_POPUP:
            return {
                ...state,
                isManageProductPopupVisible: true,
                manageProductPopupData: {
                    mode: action.mode,
                    market_id: action.market_id,
                    data: action.data,
                },
            };
        case HIDE_MANAGE_PRODUCT_POPUP:
            return {
                ...state,
                isManageProductPopupVisible: false,
                manageProductPopupData: {},
            };
        case MARKET_LOG_STORE_ARGS:
            return {
                ...state,
                marketLogArgs: action.payload,
            };
        case MARKET_LOG_SET_SELECTED_VIEW:
            return {
                ...state,
                marketLogSelectedView: action.payload,
            };
        case STORE_STATUSBAR_DATA:
            return {
                ...state,
                statusbar: {
                    ...state.statusbar,
                    product_id: action.product_id,
                    data: action.payload,
                    params: action.params,
                },
            };
        case CLEAN_STATUSBAR_DATA:
            return {
                ...state,
                statusbar: {
                    ...initialState.statusbar,
                },
            };
        case SHOW_STATUSBAR:
            return {
                ...state,
                statusbar: {
                    ...state.statusbar,
                    visible: true,
                },
            };
        case HIDE_STATUSBAR:
            return {
                ...state,
                statusbar: {
                    ...state.statusbar,
                    visible: false,
                },
            };
        case SHOW_MARKETLOG_FILTER:
            return {
                ...state,
                marketlogFilter: {
                    ...state.marketlogFilter,
                    visible: true,
                    params: action.params || [],
                },
            };
        case HIDE_MARKETLOG_FILTER:
            return {
                ...state,
                marketlogFilter: {
                    ...state.marketlogFilter,
                    visible: false,
                    params: {},
                },
            };
        case GET_CUSTOM_VIEW_REQUEST:
            return {
                ...state,
            };
        case GET_CUSTOM_VIEW_SUCCESS:
            return {
                ...state,
                error: '',
                customViews: action.payload,
            };
        case GET_CUSTOM_VIEW_FAIL:
            return {
                ...initialState,
                error: action.error || '',
            };
        case MARKET_RESET_STATE:
            return {
                ...initialState,
                data: state.data,
            };
        case UPDATE_BID:
            return {
                ...state,
                updatingBid: true,
            };
        case ADD_MARKET_ORDER_NOTIFIKATION:
            return {
                ...state,
                marketOrderNotifikation: action.payload,
            };
        case REMOVE_MARKET_ORDER_NOTIFIKATION:
            return {
                ...state,
                marketOrderNotifikation: null,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./source/reducers/markets.js